export default __webpack_public_path__ + "static/featurePhone4-afa5ee95e7e6126498cd70dc1f6de9f1.png";